import { cn } from "@/lib/utils";

interface ShimmerTextProps {
  readonly text: string;
  /** When false, renders plain text with no effect. */
  readonly active?: boolean;
  /** Native tooltip explaining why the shimmer is shown. */
  readonly tooltip?: string;
  readonly className?: string;
}

/**
 * Text with a sweeping shimmer overlay, used to convey that the displayed
 * value is provisional (e.g. the supplier-original title while AI enrichment
 * is still running). Uses the `animate-shimmer` keyframes from the Tailwind
 * config.
 */
export function ShimmerText({ text, active = true, tooltip, className }: ShimmerTextProps) {
  if (!active) {
    return (
      <span className={className} title={tooltip}>
        {text}
      </span>
    );
  }

  return (
    <span
      className={cn("relative inline-block max-w-full overflow-hidden rounded-sm", className)}
      title={tooltip}
    >
      <span className="text-muted-foreground">{text}</span>
      <span
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 animate-shimmer bg-gradient-to-r from-transparent via-foreground/25 to-transparent"
      />
    </span>
  );
}
